import { render, staticRenderFns } from "./promotion-popup.vue?vue&type=template&id=1e7a26ea&"
import script from "./promotion-popup.ts?vue&type=script&lang=ts&"
export * from "./promotion-popup.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports